<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="弹窗时长">
          <el-input size="small" v-model="searchForm.time" placeholder="请输入弹窗时长"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加弹窗</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="categoryId" border default-expand-all :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
          <el-table-column prop="pop_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="time" label="时长">
            <template slot-scope="scope" v-if="scope.row.time">
              <span style="color:green">{{scope.row.time}}小时</span>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="页面链接">
            <template slot-scope="scope" v-if="scope.row.url">
              <span style="color:red">{{scope.row.url}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="image.filePath" label="图片" width="180">
            <template slot-scope="scope" v-if="scope.row.image">
              <img :src='scope.row.image.filePath' alt="" width="50px" height="50px" />
            </template>
          </el-table-column>
          <el-table-column prop="is_show" label="是否显示" align="center" width="100">
            <template slot-scope="scope">
              <el-switch class="switch" @change='isShow(scope.row)' v-model="scope.row.is_show" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="更新时间"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import BulletboxApi from "@/api/bulletbox.js";
import Add from "./add.vue";
import Edit from "./edit.vue";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      searchForm: {
        time: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    // 是否显示音乐
    isShow(row) {
      let self = this;
      BulletboxApi.BulletisShow({
        pop_id: row.pop_id,
        is_show: row.is_show
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      BulletboxApi.BulletList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.categoryModel.model = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*删除分类*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          BulletboxApi.BulletDelete({
            pop_id: row.pop_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/marketing/bulletbox/index.vue